import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(1),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
}));

export default function AboutScreen() {

    const classes = useStyles();


    // const GetCards = (imgArr, titleArr, detailsArr, imgPathPrefix) => {
    const GetCards = (imgArr, titleArr, detailsArr) => {

        return (
            <Container className={classes.cardGrid} maxWidth="md">
                <Grid container spacing={4}>

                    {imgArr.map((imgPath, index) => (


                        <Grid item key={index} xs={12} sm={6} md={4}>

                            <Card className={classes.card}>
                                <CardMedia
                                    className={classes.cardMedia}
                                    // image={(imgPathPrefix ? imgPathPrefix : '') + imgPath}
                                    image={'/appImgs/' + imgPath}
                                    title="Image title"
                                />

                                <CardContent className={classes.cardContent}>
                                    {
                                        titleArr && titleArr[index] &&
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {titleArr[index]}
                                        </Typography>
                                    }

                                    {
                                        detailsArr && detailsArr[index] &&
                                        <Typography>
                                            {detailsArr[index]}
                                        </Typography>
                                    }
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>

        )
    }


    const getFeature = () => {
        const
            demoImgArr = ['sorting.gif', 'buying.gif', 'seller-admin.gif', 'new-prod2.gif']
            , demoTitleArr = ['Sorting', 'Buying', 'Seller & Admin', 'New Product']
            , demoDetailedArr = [
                'User can sort products by 3 methods: textual, size and more',
                'Multiple sellers, login with social buttons and make and order all at the same page.  ',
                'Create a seller or admin from registered users',
                'Create a new Product, upload image or select from your personal S3 album and MongoDB'
            ]

        return (GetCards(demoImgArr, demoTitleArr, demoDetailedArr, null))
    }

    const getTachSection = () => {
        const
            imgArr = ['mongoDB.png', 'mui.svg', 'note.png', 'passport.png', 'react.png', 'redux.png', 's3_2.jpg'],
            tTitleArr = ['MongoDB', 'Material UI', 'Note', 'Passport', 'React', 'Redux', 'S3']
        // tDescArr = ['', '', '', '', '', '', '', '', '', '',]

        return (
            GetCards(imgArr, tTitleArr, null, '/appImgs/')
        )
    }




    return (
        <main>
            {/* Hero unit */}
            <div className={classes.heroContent}>
                <Container maxWidth="sm">
                    <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                        Shopping Cart N:5
                    </Typography>
                    <Typography variant="h5" align="center" color="textSecondary" paragraph>
                        Multiple Seller per buying and multiple Admin management App.
                    </Typography>


                    <div className={classes.heroButtons}>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item>
                                <a href="http://sp-software.tk/" target='_blank' rel="noreferrer">
                                    <Button variant="contained" color="primary">
                                        Get in Contact
                                    </Button></a>
                            </Grid>
                            <Grid item>
                                <a href="http://sps-ws.ml/" target='_blank' rel="noreferrer">
                                    <Button variant="outlined" color="primary">
                                        See Another solutions
                                    </Button>
                                </a>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </div>


            {getFeature()}

            {/* section tec */}

            <div className={classes.heroContent}>
                <Container maxWidth="sm"    >
                    <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom
                        style={{
                            transform: "rotate(9deg) translateX(-22%)",
                            border: "14px solid yellow",
                            overflow: "hidden",
                            width: "186%",
                            color: "rgb(208, 208, 24)",
                            height: "14rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            letterSpacing: "1.3px",
                            fontSize: "3rem",
                            boxShadow: '0px -8px 0px #e81717',
                            borderRadius: '11px'
                        }}
                    >
                        <span style={{
                            margin: '0 1rem 0 -2rem',
                            fontWeight: '800',
                            textShadow: '14px -8px 0px #e81717'
                        }}
                        >7</span>
                        Technologies
                    </Typography>
                </Container>
            </div>


            {
                getTachSection()
            }



        </main>
    )
}
